export class CommitmentDialogData {
    userId: number;
    dataRangeId: number;
    evaluationRangeId: number;
}
